import { useState } from 'react';

/**
 * Tracks which chart series are focused via legend clicks. An empty
 * selection means every series is visible.
 */
export function useSeriesSelection(availableKeys: string[]) {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const effectiveKeys = selectedKeys.filter((key) =>
    availableKeys.includes(key),
  );

  const isVisible = (key: string) =>
    effectiveKeys.length === 0 || effectiveKeys.includes(key);

  const toggle = (key: string) => {
    setSelectedKeys(
      effectiveKeys.includes(key)
        ? effectiveKeys.filter((selectedKey) => selectedKey !== key)
        : [...effectiveKeys, key],
    );
  };

  return { isVisible, toggle };
}

export function getLegendClickKey(legendEntry: { dataKey?: unknown }) {
  return String(legendEntry.dataKey ?? ``);
}
